module.exports = __webpack_public_path__ + "static/media/V7.b4d26628.png";